import { render, staticRenderFns } from "./leftColSobreA_Mobile.vue?vue&type=template&id=6783c90a"
import script from "./leftColSobreA_Mobile.vue?vue&type=script&lang=js"
export * from "./leftColSobreA_Mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports